import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../../config/apiClient"
import DataTable from "../../../../components/dataTable/DataTable"
import dayjs from "dayjs"

function NfseModelosListarPage() {
    const [modelos, setModelos] = useState<any[]>([])

    useEffect(() => {
        document.title = "NFSe Modelos | OB PORTUS"

        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.nfseModelos)

        if (api.status === 200) {
            const dadosAux:any[] = api.data
            setModelos(dadosAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = modelos[idx]
        const link = `/nfse/modelo?id=${reg.id_modelo}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = modelos[idx]
        const link = `/nfse/modelo?id=${reg.id_modelo}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">NFS-e Modelos</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`/nfse/modelo`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={modelos} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default NfseModelosListarPage

const columnHelper = createColumnHelper<any>()
const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

const defaultColumns = [
    columnHelper.accessor('id_modelo', {
        header: 'ID',
        size: 10,
        minSize: 10,
        maxSize: 150
    }),
    columnHelper.accessor('nome', {
        header: 'Modelo',
        size: 280,
        minSize: 150,
        maxSize: 300
    }),
    columnHelper.accessor(row => `${row.situacao === 1 ? "Ativo" : "Inativo"}`, {
        header: 'Situação'
    }),
    columnHelper.accessor(row => `${row.id_empresa.nome}`, {
        header: 'Empresa'
    }),
    columnHelper.accessor(row => `${row.id_cliente.nome} ${row.id_cliente.tipo === 'PJ' ? `CNPJ ${row.id_cliente.cnpj}` : `CPF ${row.id_cliente.cpf}`}`, {
        header: 'Cliente',
        size: 450,
        minSize: 150,
        maxSize: 450
    }),
    columnHelper.accessor(row => `${moneyFormatter.format(row.valor_servicos)}`, {
        header: 'Valor Serviços'
    }),
    columnHelper.accessor(row => `${row.servico_dia_data_servico.length === 1 ? `0${row.servico_dia_data_servico}` : row.servico_dia_data_servico}/mm/yyyy`, {
        header: 'Dia Data Serviço'
    }),
    columnHelper.accessor(row => `${row.tipo === 1 ? "Mensal" : "Apenas Modelo"}`, {
        header: 'Tipo'
    }),
    columnHelper.accessor(row => dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss"), {
        header: 'Criado em'
    }),
]

const defaultOrder:any = []